import {api} from "./axios"
export function getOrdersApi(params ={}) {
    return api.get(`crm/orders`, {params})
}

export function uploadInvoicesApi(data, params = {}) {
    return api.post(`/crm/orders/invoices/upload`, data, {params})
}

export function downloadInvoicesApi(id) {
    return api.get(`/crm/orders/invoices/${id}/download-url`)
}

export function getOrdersSummaryApi() {
    return api.get(`/crm/orders/summary`)
}
